import script from "./side-menu-item.vue?vue&type=script&setup=true&lang=js"
export * from "./side-menu-item.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__